import { apiSlice } from '../apiSlice';
import { SuccessResponse } from '../DTO/common.interface';
import {
	Dsm5AdultDTO,
	Dsm5AdultRequest,
	Dsm5AdultSaveDTO,
} from '../DTO/forms-management/dsm5adult';

export const dsm5Adult = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		getDsm5AdultList: builder.query<SuccessResponse<Dsm5AdultDTO[]>, string>({
			query: (id) => ({
				url: `/web/form/dsm-five-adult/list/${id}`,
				method: 'GET',
			}),
			providesTags: ['Dsm5AdultList'],
		}),
		deleteDsm5Adult: builder.mutation<SuccessResponse<any>, string>({
			query: (id) => ({
				url: `/web/form/dsm-five-adult/${id}`,
				method: 'DELETE',
			}),

			invalidatesTags: ['Dsm5AdultList'],
		}),
		Dsm5AdultHasDraft: builder.query<SuccessResponse<any>, string>({
			query: (id) => ({
				url: `/web/form/dsm-five-adult/has-draft/${id}`,
				method: 'GET',
			}),
			keepUnusedDataFor: 0,
		}),
		getDsm5AdultDraft: builder.query<
			SuccessResponse<Dsm5AdultSaveDTO>,
			{ id: string; type: string }
		>({
			query: ({ id, type }) => ({
				url: `/web/form/dsm-five-adult/to-create/${id}/${type}`,
				method: 'GET',
			}),
		}),
		continueDsm5AdultDraft: builder.mutation<
			SuccessResponse<Dsm5AdultSaveDTO>,
			{ id: string; type: number }
		>({
			query: ({ id, type }) => ({
				url: `/web/form/dsm-five-adult/to-create/${id}/${type}`,
				method: 'GET',
			}),
		}),
		editDsm5Adult: builder.mutation<SuccessResponse<any>, Dsm5AdultRequest>({
			query: (body) => ({
				url: `/web/form/dsm-five-adult/${body.id}`,
				method: 'PUT',
				body,
			}),
		}),
		createDsm5Adult: builder.mutation<SuccessResponse<any>, Dsm5AdultRequest>({
			query: (body) => ({
				url: `/web/form/dsm-five-adult`,
				method: 'POST',
				body,
			}),
		}),
		getDsm5AdultDetail: builder.query<SuccessResponse<Dsm5AdultDTO>, string>({
			query: (id) => ({
				url: `/web/form/dsm-five-adult/${id}`,
				method: 'GET',
			}),
		}),
	}),
});

export const {
	useGetDsm5AdultListQuery,
	useDeleteDsm5AdultMutation,
	useDsm5AdultHasDraftQuery,
	useGetDsm5AdultDraftQuery,
	useContinueDsm5AdultDraftMutation,
	useEditDsm5AdultMutation,
	useCreateDsm5AdultMutation,
	useGetDsm5AdultDetailQuery,
} = dsm5Adult;
